import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=7bd68bd0&"
import script from "./Clients.vue?vue&type=script&lang=js&"
export * from "./Clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd68bd0')) {
      api.createRecord('7bd68bd0', component.options)
    } else {
      api.reload('7bd68bd0', component.options)
    }
    module.hot.accept("./Clients.vue?vue&type=template&id=7bd68bd0&", function () {
      api.rerender('7bd68bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configurations/Clients.vue"
export default component.exports